





























































import RepairEstimatePartyForm from "@/components/repair-estimate/RepairEstimatePartyForm.vue";
import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import RefsRepairEstimate from "@/components/utility/RefsRepairEstimate.vue";
import RefsSelect from "@/components/utility/RefsSelect.vue";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { Reference } from "@/models/reference.entity";
import { IRepairEstimate } from "@/models/repair-estimate.entity";
import { ISharedContent, SharedContent } from "@/models/shared-content.entity";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import { PreselectTemplateKeysEnum } from "@/lib/enum/preselect-template-keys.enum";

export enum RepairEstimateSteps {
  SELLER = "seller",
  EXPIRATION = "expiration",
  SEND_MAIL = "sendMail",
  SUCCESS = "success"
}

@Component({
  components: { RepairEstimatePartyForm, PreselectTemplateCard, RefsRepairEstimate, RefsSelect },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class RepairEstimateCreateStepper extends mixins(PermissionMixin) {
  readonly RepairEstimateSteps = RepairEstimateSteps;

  readonly PreselectTemplateKeysEnum = PreselectTemplateKeysEnum;

  @Ref("templateCard")
  templateCard!: PreselectTemplateCard;

  @Prop()
  value!: IRepairEstimate;

  @Prop()
  step!: RepairEstimateSteps;

  @Prop({ default: false })
  hideRefsSelect!: boolean;

  @Prop({ default: false })
  refsSelectAsList!: boolean;

  @Prop()
  sellerCompanyId?: string;

  sharedContent: ISharedContent = new SharedContent({ partnerId: this.value.partnerId });

  requestsLoading = false;

  get categories(): BackendResourceEnum[] {
    return [BackendResourceEnum.REPORT];
  }

  get stepLocal() {
    return this.step;
  }

  set stepLocal(step: RepairEstimateSteps) {
    this.$emit("update:step", step);
  }

  get templateRefs() {
    return [...this.value.refs, { refId: this.value.id, refType: ResourceEnum.REPAIR_ESTIMATE }];
  }

  get partner() {
    return PartnerModule.partner;
  }

  get context() {
    return {
      repairEstimate: this.value,
      sharedContent: this.sharedContent,
      partner: this.partner,
      url: { sharing: this.sharedContent.url }
    };
  }

  mounted() {
    this.setSellerFromCompanyId();
  }

  @Watch("sellerCompanyId")
  setSellerFromCompanyId() {
    if (this.sellerCompanyId) {
      (this.$refs.sellerForm as RepairEstimatePartyForm)?.setInvoicePartyFromCompanyOrPersonRef([
        {
          refId: this.sellerCompanyId,
          refType: ResourceEnum.COMPANY
        }
      ]);
    }
  }

  async createRequests() {
    this.requestsLoading = true;
    try {
      if (!this.value.id) {
        await this.value.create();
      }

      this.sharedContent.refs = [...this.value.refs];
      if (this.value.id) {
        this.sharedContent.refs.push(new Reference({ refId: this.value.id, refType: ResourceEnum.REPAIR_ESTIMATE }));
      } else {
        throw new Error("Repair estimate request ID is not defined");
      }

      await this.sharedContent.create();
      this.$emit("create:sharedContent", this.sharedContent);
      this.stepLocal = RepairEstimateSteps.SEND_MAIL;
    } catch (e) {
      handleError(e);
    }
    this.requestsLoading = false;
  }
}
